<template>
  <div class="mdfb-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <div class="card-title">
            门店分布
          </div>
          <div class="card-content">
            <el-row :gutter="1">
              <el-col :span="18">
                <HighMap v-if="flage" :id="'map'" :option="option"/>
              </el-col>
              <el-col :span="5">
                <el-table
                  :data="mapNum"
                  style="width: 100%">
                  <el-table-column
                    label="地区"
                    min-width="100"
                    prop="name"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    label="门店数量"
                    min-width="100"
                    prop="num"
                    show-overflow-tooltip>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import baiduMap from '../../../components/baiduMap/index'
import { getDealerList } from '@/api/work'
import HighMap from '../../../components/Charts/Map'
import CN from '@/utils/CN'
import { getHeighMapData } from '@/api/tj'

export default {
  name: 'delmap',
  components: {
    baiduMap,
    HighMap
  },
  data() {
    return {
      data: '',
      dealerList: [],
      flage: false,
      mapList: [],
      mapNum: [],
      option: {
        title: {
          text: '门店分布'
        },
        mapNavigation: {
          enabled: true,
          buttonOptions: {
            verticalAlign: 'left'
          }
        },
        colorAxis: {
          min: 0
        },
        credits: {
          enabled: false
        },
        legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'bottom'
        },
        series: [{
          data: [],
          mapData: CN,
          joinBy: 'name',
          name: '门店数量',
          states: {
            hover: {
              color: '#a4edba'
            }
          },
          dataLabels: {
            enabled: true,
            format: '{point.name}'
          }
        }] }
    }
  },
  created() {
    this.getHeighMapData()
  },
  methods: {
    getBaiDuData() {
      const data = {
        page: 1,
        limit: 10000
      }
      getDealerList(data).then(response => {
        for (const item of response.data) {
          if (item.lng !== '' && item.lat !== '') {
            const map = {
              center: {
                lat: '',
                lng: ''
              },
              address: item.address,
              id: item.delid,
              allName: item.allname,
              tel: item.tel
            }
            map.center.lat = item.lat
            map.center.lng = item.lng
            this.mapList.push(map)
          }
        }
        this.flage = true
      })
    },
    getHeighMapData() {
      getHeighMapData().then(response => {
        this.mapNum = response.data
        const dataArr = []
        for (const item of response.data) {
          const data = {
            name: '',
            value: 0
          }
          data.name = item.name
          data.value = item.num
          dataArr.push(data)
        }
        this.option.series[0].data = dataArr
        this.flage = true
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
